export default __webpack_public_path__ + "static/media/LegacyCarWashAd-1024x602.dd02a59d.jpg";